export default function Chip({ active, label, color, onClick, testId }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      className="flex-shrink-0 px-3.5 py-1.5 rounded-full text-[13px] uppercase tracking-wide transition-all"
      style={{
        // May 2026 user spec: chips need to be readable — bump font size,
        // brighten inactive text from #71717A (mid-grey) to near-white, and
        // sharpen the inactive border so each pill is clearly demarcated.
        background: active ? '#FFFFFF' : '#1A1A1A',
        color: active ? '#000000' : '#E5E7EB',
        border: active
          ? `2px solid ${color || '#FFFFFF'}`
          : '1.5px solid rgba(255,255,255,0.22)',
        fontWeight: active ? 900 : 800,
        fontFamily: 'Manrope, sans-serif',
        boxShadow: active ? '0 0 0 1px rgba(0,0,0,0.4)' : 'none',
      }}
    >
      {label}
    </button>
  );
}
